import { isAxiosError } from 'axios';

export function getErrorMessage(error, fallback = 'Request failed') {
  if (isAxiosError(error)) {
    const data = error.response?.data;
    const msg = data?.message || data?.error;
    if (typeof msg === 'string' && msg.trim()) return msg;
    if (error.response?.status === 409) {
      return 'Email already exists. Please use a different email.';
    }
    if (error.code === 'ECONNABORTED' || /timeout/i.test(String(error.message || ''))) {
      return 'Upload timed out. Large files on slow networks can take several minutes — please keep this tab open and try again.';
    }
    if (!error.response && error.message === 'Network Error') {
      return 'Network error during upload. Please check your connection and try again.';
    }
    return fallback;
  }
  if (error instanceof Error) return error.message;
  return fallback;
}
